import { useMemo } from 'react';
import endpoints from '@services/api/endpoints';
import useFetch from '@services/api/useFetch';

export const useCustomerPortalApi = () => {
  const api = useFetch();

  return useMemo(() => {
    return {
      async fetchToken(organizationId: string, vendorId = ''): Promise<string> {
        return await api.post(endpoints.customerPortal.fetchToken, {
          organizationId,
          vendorId,
        });
      },
    };
  }, [api]);
};

export const customerPortalApiKeys = {
  all: ['customerPortal'] as const,
  fetchToken: (organizationId: string, vendorId = '') =>
    [
      ...customerPortalApiKeys.all,
      'fetchToken',
      organizationId,
      vendorId,
    ] as const,
};
